import { render } from "./ConfirmingButton.vue?vue&type=template&id=76dd4ae4&scoped=true&ts=true"
import script from "./ConfirmingButton.vue?vue&type=script&lang=ts"
export * from "./ConfirmingButton.vue?vue&type=script&lang=ts"

import "./ConfirmingButton.vue?vue&type=style&index=0&id=76dd4ae4&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dd4ae4"]])

export default __exports__